import { Alerta, Button, Row, Stack, TextField } from "@/components";
import type { Fideicomiso } from "@/lib/api";
import { useNuevoDesarrollo } from "./useNuevoDesarrollo";

export interface NuevoDesarrolloProps {
  alCrear: (creado: Fideicomiso) => Promise<void> | void;
  onCancelar?: () => void;
}

/** Formulario de alta de un desarrollo. Lo usa la pantalla del primer desarrollo y el diálogo "Nuevo desarrollo". */
export function NuevoDesarrollo({ alCrear, onCancelar }: NuevoDesarrolloProps) {
  const t = useNuevoDesarrollo(alCrear);
  return (
    <form onSubmit={(e) => void t.crear(e)} noValidate>
      <Stack espacio={4}>
        <TextField
          etiqueta="Nombre del desarrollo"
          placeholder="Ej.: Torre Norte"
          autoFocus
          value={t.nombre}
          onChange={(e) => t.cambiarNombre(e.target.value)}
          error={t.errorNombre}
          ayuda="Después, desde el Inicio, cargás el fideicomiso, el terreno y la obra"
        />
        <Alerta texto={t.error} />
        <Row justificar="fin">
          {onCancelar && (
            <Button type="button" variante="secundario" onClick={onCancelar}>
              Cancelar
            </Button>
          )}
          <Button type="submit" cargando={t.creando}>
            Crear desarrollo
          </Button>
        </Row>
      </Stack>
    </form>
  );
}
